import React, { useState, useEffect } from "react";
import "react-simple-keyboard/build/css/index.css";
import { useTranslation } from "react-i18next";
import moment from "moment";
import { ApiKey, ApiUrl } from "../../util/Constant";
import ApiEngine from "../../util/ApiEngine";
import { stringIsNullOrEmpty, numberWithCurrencyFormat } from "../../util/Util";
import DynamicLoadTable from "../../components/custom/DynamicLoadTable";
import ContentHeader from "components/content/header";
import DateRangeFilter from "../../components/custom/DateRangeFilter";

const WinlossReports = (props) => {
  const { t } = useTranslation();
  const [winlossUrl, setWinlossUrl] = useState("");
  const [winlossData, setWinlossData] = useState([]);
  const [selectedDate, setSelectedDate] = useState("");
  const [startDate, setStartDate] = useState(moment().startOf("week").format("YYYY-MM-DD"));
  const [endDate, setEndDate] = useState(moment().endOf("week").format("YYYY-MM-DD"));

  useEffect(() => {
    getWinlossData(startDate, endDate);
  }, []);

  async function getWinlossData(start, end, selected = "") {
    // TODO: Replace with actual API endpoint when available
    var apiUrl =
      "/api/report/winloss" +
      "?StartDate=" +
      moment(start).format("YYYY-MM-DD") +
      "&EndDate=" +
      moment(end).format("YYYY-MM-DD") +
      "&v=" +
      Date.now();

    if (!stringIsNullOrEmpty(selected)) {
      apiUrl += "&SelectedDate=" + moment(selected).format("YYYY-MM-DD");
    }
    setWinlossUrl(apiUrl);
  }

  useEffect(() => {
    if (!stringIsNullOrEmpty(selectedDate)) {
      getWinlossData(startDate, endDate, selectedDate);
    }
  }, [selectedDate]);

  function getRecordFromDynamicLoad(data) {
    setWinlossData(data);
  }

  return (
    <>
      <section className="section-padding" id="winloss-report-section">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <ContentHeader enableBackButton title={t("WINLOSS_REPORTS")} />
              <hr className="right-title-hr" />
              <div className="template-box mt-3" id="winloss-report-box">
                <DateRangeFilter
                  startDate={startDate}
                  endDate={endDate}
                  setStartDate={setStartDate}
                  setEndDate={setEndDate}
                  onSave={(start, end) => {
                    setStartDate(moment(start));
                    setEndDate(moment(end));
                    getWinlossData(start, end);
                    setSelectedDate("");
                  }}
                  options={true}
                />
                <div className="card card-package">
                  <div className="card-body p-0" style={{ overflowX: "auto" }}>
                    <table className="table reportTable">
                      <thead>
                        <tr>
                          <th>{t("DATE")}</th>
                          <th>{t("USERNAME")}</th>
                          <th>{t("GAME")}</th>
                          <th style={{ textAlign: 'right' }}>{t("BET_AMOUNT")}</th>
                          <th style={{ textAlign: 'right' }}>{t("WIN_AMOUNT")}</th>
                          <th style={{ textAlign: 'right' }}>{t("NET_RESULT")}</th>
                          <th style={{ textAlign: 'right' }}>{t("STATUS")}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <DynamicLoadTable
                          returnRecord={getRecordFromDynamicLoad}
                          pageSize={20}
                          apiQuery={winlossUrl}
                          isTable={true}
                          searchEnabled={true}
                          render={(item, i) => {
                            let isGrouped =
                              moment(endDate, "YYYY-MM-DD").diff(
                                moment(startDate, "YYYY-MM-DD"),
                                "days"
                              ) >= 1 && stringIsNullOrEmpty(selectedDate);
                            
                            const betAmount = parseFloat(item["betAmount"] || 0);
                            const winAmount = parseFloat(item["winAmount"] || 0);
                            const netResult = winAmount - betAmount;
                            
                            return (
                              <tr key={"winloss_report_" + i}>
                                <td
                                  className={isGrouped ? "hoverable" : ""}
                                  onClick={() => {
                                    if (isGrouped) {
                                      setSelectedDate(moment(item["date"], 'MM/DD/YYYY').format('YYYY-MM-DD'));
                                    }
                                  }}
                                >
                                  {item["date"]}
                                </td>
                                <td>{item["username"]}</td>
                                <td>{item["gameName"]}</td>
                                <td>
                                  {numberWithCurrencyFormat(betAmount, 2)}
                                </td>
                                <td>
                                  {numberWithCurrencyFormat(winAmount, 2)}
                                </td>
                                <td>
                                  <span className={netResult >= 0 ? "text-success" : "text-danger"}>
                                    {numberWithCurrencyFormat(netResult, 2)}
                                  </span>
                                </td>
                                <td>
                                  <span className={`badge ${
                                    item["status"] === "Completed" ? "badge-success" : 
                                    item["status"] === "Pending" ? "badge-warning" : 
                                    "badge-danger"
                                  }`}>
                                    {item["status"]}
                                  </span>
                                </td>
                              </tr>
                            );
                          }}
                        />
                      </tbody>
                      <tfoot>
                        <tr>
                          <td colSpan="3">
                            <b>{t("TOTAL")}</b>
                          </td>
                          <td>
                            <b>
                              {numberWithCurrencyFormat(
                                parseFloat(
                                  winlossData.reduce(
                                    (total, data) => total + parseFloat(data.betAmount || 0),
                                    0
                                  )
                                ),
                                2
                              )}
                            </b>
                          </td>
                          <td>
                            <b>
                              {numberWithCurrencyFormat(
                                parseFloat(
                                  winlossData.reduce(
                                    (total, data) => total + parseFloat(data.winAmount || 0),
                                    0
                                  )
                                ),
                                2
                              )}
                            </b>
                          </td>
                          <td>
                            <b>
                              {numberWithCurrencyFormat(
                                parseFloat(
                                  winlossData.reduce(
                                    (total, data) => {
                                      const bet = parseFloat(data.betAmount || 0);
                                      const win = parseFloat(data.winAmount || 0);
                                      return total + (win - bet);
                                    },
                                    0
                                  )
                                ),
                                2
                              )}
                            </b>
                          </td>
                          <td></td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default WinlossReports;
